import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import tr from 'vuetify/lib/locale/tr'
import en from 'vuetify/lib/locale/en'
import ru from 'vuetify/lib/locale/ru'
import { resolveInitialLocale } from '../i18n'
Vue.use(Vuetify)
const vuetify = new Vuetify({
    theme: {
      themes: {
        light: {
          // primary: '#90C143',
          primary: '#3ca8bf',
          secondary: '#b0bec5',
          anchor: '#8c9eff',
        },
      },
    },
  })
const opts = {
  lang: {
    locales: { tr, en, ru },
    current: resolveInitialLocale(),
  },
}

export default new Vuetify(opts)
